import lunr from "lunr"

const searchInput = document.getElementById("search-input")
if (searchInput) {
  const resultsContainer = document.getElementById("search-results")
  let index = null
  let documents = {}

  fetch("/bridgetown_quick_search/index.json")
    .then(r => r.json())
    .then(data => {
      data.forEach(doc => { documents[doc.url] = doc })
      index = lunr(function () {
        this.ref("url")
        this.field("title", { boost: 10 })
        this.field("content")
        data.forEach(doc => this.add(doc))
      })
    })

  searchInput.addEventListener("input", () => {
    const query = searchInput.value.trim()
    if (!index || query.length < 2) {
      resultsContainer.innerHTML = ""
      return
    }
    const results = index.search(query + "*")
    if (results.length === 0) {
      resultsContainer.innerHTML = "<p class='text-gray-500'>No results found.</p>"
      return
    }
    resultsContainer.innerHTML = results.map(({ ref }) => {
      const doc = documents[ref]
      const dateMatch = doc.url.match(/^\/(\d{4})\/(\d{2})\//)
      const date = dateMatch
        ? new Date(`${dateMatch[1]}-${dateMatch[2]}-01`).toLocaleDateString("en-US", { year: "numeric", month: "long" })
        : null
      return `
        <div class="mb-6">
          <a href="${doc.url}" class="text-xl font-bold hover:underline">${doc.title}</a>
          ${date ? `<div class="text-sm text-gray-500 mt-1">${date}</div>` : ""}
          <p class="text-gray-600 mt-1">${doc.content.slice(0, 200)}...</p>
        </div>`
    }).join("")
  })

  // Run search immediately if there's a query param
  const params = new URLSearchParams(window.location.search)
  const q = params.get("q")
  if (q) {
    searchInput.value = q
    searchInput.dispatchEvent(new Event("input"))
  }
}
